function noop() {}

function callable(fn) {
    return fn || noop
}

export { noop }
export { callable }
